import { useMemo } from 'react';
import { validationCopy } from '../copy/validationCopy';
import type { ValidationWorkspaceState } from './useValidationWorkspace';

export interface DetailEmptyState {
  title: string;
  description: string;
  steps?: string[];
  emptyStateActionLabel?: string;
  onEmptyStateAction?: () => void;
}

export function useValidationDetailEmptyState(
  workspace: ValidationWorkspaceState,
  hasActiveFilters: boolean,
  onClearFilters: () => void
): DetailEmptyState {
  return useMemo(() => {
    if (workspace.showPassedOnly) {
      return {
        title: validationCopy.detailPanel.emptyState.passedReview.title,
        description: validationCopy.detailPanel.emptyState.passedReview.description,
        steps: validationCopy.detailPanel.emptyState.passedReview.steps,
        emptyStateActionLabel: validationCopy.detailPanel.emptyState.passedReview.action,
        onEmptyStateAction: () => workspace.setShowPassedOnly(false),
      };
    }

    if (workspace.allFamilies.length === 0) {
      return {
        title: validationCopy.detailPanel.emptyState.clear.title,
        description: validationCopy.detailPanel.emptyState.clear.description,
        steps: validationCopy.detailPanel.emptyState.clear.steps,
      };
    }

    if (hasActiveFilters && workspace.filteredFamilies.length === 0 && workspace.allFamilies.length > 0) {
      return {
        title: validationCopy.detailPanel.emptyState.noMatch.title,
        description: validationCopy.detailPanel.emptyState.noMatch.description,
        steps: validationCopy.detailPanel.emptyState.noMatch.steps,
        emptyStateActionLabel: validationCopy.detailPanel.emptyState.noMatch.action,
        onEmptyStateAction: onClearFilters,
      };
    }

    return {
      title: validationCopy.detailPanel.emptyState.selectIssueFamily.title,
      description: validationCopy.detailPanel.emptyState.selectIssueFamily.description,
      steps: validationCopy.detailPanel.emptyState.selectIssueFamily.steps,
    };
  }, [
    workspace.allFamilies.length,
    workspace.filteredFamilies.length,
    workspace.setShowPassedOnly,
    workspace.showPassedOnly,
    hasActiveFilters,
    onClearFilters,
  ]);
}
